import { Component, OnInit, Input } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { LokalOrderService } from 'app/services';
import { Utils } from 'app/utils';

enum MartOrderDetailsTab {
    Info = '1',
    Products = '2',
    Payment = '3',
    Messages = '4',
    Timeline = '5'
}

@Component({
    selector: 'mart-order-details',
    templateUrl: './mart-order-details.component.html',
    styleUrls: ['./mart-order-details.component.scss'],
    providers: [MessageService]
})
export class MartOrderDetailsComponent implements OnInit {
    @Input()
    public orderId: number = 0;

    @Input()
    public onHide: () => void = () => { };

    public order: any = {};
    public orderDateStr: string = '';
    public orderTimeStr: string = '';
    public deliveryCreatedTimeStr: string = '';
    public deliveryCompletedDateStr: string = '';
    public deliveryCompletedTimeStr: string = '';
    public acceptedAtTimeStr: string = '';
    public packingStartedAtTimeStr: string = '';
    public readyToDispatchAtTimeStr: string = '';
    public dispatchAtTimeStr: string = '';
    public deliveredAtTimeStr: string = '';

    public menuItems: MenuItem[] = [
        {
            id: MartOrderDetailsTab.Info,
            label: 'Order Details'
        },
        {
            id: MartOrderDetailsTab.Products,
            label: 'Products'
        },
        {
            id: MartOrderDetailsTab.Payment,
            label: 'Payment'
        },
        {
            id: MartOrderDetailsTab.Messages,
            label: 'Messages'
        },
        {
            id: MartOrderDetailsTab.Timeline,
            label: 'Timeline'
        }
    ];

    public martOrderDetailsTab = MartOrderDetailsTab;
    public activeItem: MenuItem = this.menuItems[0];

    public isSpinnerVisible: boolean = true;

    constructor(
        private messageService: MessageService,
        private lokalOrderService: LokalOrderService) {
    }

    ngOnInit(): void {
        this.getOrder();
    }

    private getOrder(): void {
        const dto = {
            OrderId: this.orderId
        };

        this.lokalOrderService.getLokalOrderDetails(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.order = data;

                this.orderDateStr = Utils.utcToLocaleDateString(this.order.CreatedAt);
                this.orderTimeStr = Utils.utcToLocaleTimeString(this.order.CreatedAt);
                this.deliveryCreatedTimeStr = Utils.utcToLocaleTimeString(this.order.DeliveryCreatedAt);
                this.deliveryCompletedDateStr = Utils.utcToLocaleDateString(this.order.DeliveryCompletedAt);
                this.deliveryCompletedTimeStr = Utils.utcToLocaleTimeString(this.order.DeliveryCompletedAt);
                this.acceptedAtTimeStr = Utils.utcToLocaleTimeString(this.order.AcceptedAt);
                this.packingStartedAtTimeStr = Utils.utcToLocaleTimeString(this.order.PackingStartedAt);
                this.readyToDispatchAtTimeStr = Utils.utcToLocaleTimeString(this.order.ReadyToDispatchAt);
                this.dispatchAtTimeStr = Utils.utcToLocaleTimeString(this.order.DispatchAt);
                this.deliveredAtTimeStr = Utils.utcToLocaleTimeString(this.order.DeliveredAt);

                for (const message of this.order.Messages) {
                    message.CreatedAt = Utils.utcToLocaleString(message.CreatedAt);
                }

                this.isSpinnerVisible = false;
            });
    }

    public onSideBarHide(): void {
        this.onHide();
    }

    public onActiveItemChange(item: any): void {
        this.activeItem = item;
    }
}
